import { z } from 'zod';

export const ItemSelectionTaskSchema = z.object({
  id: z.string().min(1, { message: 'ID missing' }),
  quantity: z.number().positive({ message: 'Qty must be positive' }),
  trackingNumber: z.string().optional(),
  sourceItemId: z.string().optional(), // For virtual items, tracks the real item they represent
});

export type ItemSelectionData = {
  itemSelection: z.infer<typeof ItemSelectionTaskSchema>;
};
